var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 132,
    viewBox: "0 0 82 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.84 72.534C32.68 67.494 36.04 62.214 38.92 56.694C41.8 51.174 43.24 46.074 43.24 41.394C43.24 37.074 41.56 34.074 38.2 32.394C34.84 30.594 30.76 29.694 25.96 29.694C22.72 29.694 19.3 29.994 15.7 30.594C12.1 31.194 8.74 32.034 5.62 33.114L0.22 6.65404C6.7 4.61404 13.12 3.05404 19.48 1.97404C25.84 0.894035 31.84 0.354035 37.48 0.354035C45.64 0.354035 52.84 1.55404 59.08 3.95404C65.44 6.35404 70.42 10.194 74.02 15.474C77.62 20.634 79.42 27.474 79.42 35.994C79.42 43.314 77.86 50.454 74.74 57.414C71.62 64.254 67.6 70.854 62.68 77.214L43.24 102.594H81.76V131.394H1.3V108.714L28.84 72.534Z",
    fill: "url(#paint0_linear_7699_379)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7699_379",
    x1: 41.5,
    y1: -47.606,
    x2: 41.129,
    y2: 117.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33472,
    stopColor: "#1A76D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.910921b06e6560aea0b0286bc875df28.svg";
export { ForwardRef as ReactComponent };